exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../../../css-loader/dist/cjs.js??ref--8-1!../../styles/custom-properties.css"), "");
// Module
exports.push([module.id, "html[dir] ._1ImZPNmk5JJQ-NxKnwBlo9{margin:0 16px;margin-top:16px}._39U7AzE-OP1Uv4XD9vTaSc{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;font-size:14px}html[dir] ._39U7AzE-OP1Uv4XD9vTaSc{padding:8px 4px}html[dir] ._1Yh0Ktu6VaULeOiZxN8BU1{margin:0 4px;margin-top:2px}._2JINjOz5Qp7DFZUUaC4spN{color:#666}html[dir] ._2JINjOz5Qp7DFZUUaC4spN{margin:0 4px}", ""]);
// Exports
exports.locals = {
	"n-futureNotesInfo": "_1ImZPNmk5JJQ-NxKnwBlo9",
	"n-futureNotesInfo-content": "_39U7AzE-OP1Uv4XD9vTaSc",
	"n-futureNotesInfo-icon": "_1Yh0Ktu6VaULeOiZxN8BU1",
	"n-futureNotesInfo-text": "_2JINjOz5Qp7DFZUUaC4spN"
};